import { Form, Formik } from 'formik';
import * as Yup from 'yup';
import { use, useEffect, useRef, useState } from 'react';
import { useLocation, useNavigate } from 'react-router';
import { useDispatch, useSelector } from 'react-redux';
import {
  fetchAttachmentsAndAppendToModule,
  fetchDetailAndAppendToModule,
  fetchEmailAndAppendToModule,
  fetchNotesAndAppendToModule,
  fetchTagsAndAppendToModule,
} from '../../redux/actions';
import { getOpportunityById, getOpportunityList } from '../../redux/selector';
import Loader from '../../shared/component/Loader';
import DealForm from './dealForm';
import HeaderProfileBlock from '../sharedChild/headerImage/headerProfileBlock';
import Notes from '../sharedChild/note/notes';
import Attachments from '../sharedChild/attachment/attachments';
import Timeline from '../sharedChild/timeline';
import edit from '../../../src/assets/img/crm_home/header/edit.png';
import addNote from '../../../src/assets/img/crm_home/header/addNote.png';

const validationSchema = Yup.object().shape({
  businessType: Yup.string().required('Business Type is required'),
  industry: Yup.string().required('Industry is required'),
});

const ViewDeal = () => {
  const refs = {
    overview: useRef(null),
    attachments: useRef(null),
    timeline: useRef(null),
  };
  const [activeTab, setActiveTab] = useState('overview');
  const navigate = useNavigate();
  const location = useLocation();
  const dispatch = useDispatch();
  const [formData, setFormData] = useState(null);
  const [errormsg, setErrorMsg] = useState({});
  const [loading, setLoading] = useState(false);
  const [selectedOptions, setSelectedOptions] = useState({});

  const searchParams = new URLSearchParams(location.search);
  const opportunityID = searchParams.get('id');
  const [opportunityLocalData, setOpportunityLocalData] = useState(location.state || {});
  const opportunityStoreData = useSelector((state) => {
    const opportunityId = location.state?.id || opportunityID;
    return getOpportunityById(state, opportunityId);
  });
  useEffect(() => {
    setOpportunityLocalData((prev) => ({ ...prev, ...opportunityStoreData }));
  }, [opportunityStoreData]);
  const opportunityList = useSelector(getOpportunityList);
  const handleFormSubmit = () => {};
  const handleSubmit = async (formData) => {
    try {
      await validationSchema.validate(formData, { abortEarly: false });
      handleFormSubmit(formData);
    } catch (error) {
      const fieldErrors = {};
      error.inner.forEach((err) => {
        fieldErrors[err.path] = err.message;
      });
      setErrorMsg(fieldErrors);
      console.error('Validation Error:', fieldErrors);
    }
  };

  const scrollToSection = (id) => {
    if (refs[id]?.current) {
      refs[id].current.scrollIntoView({
        behavior: 'smooth', // Smooth scrolling
        block: 'center', // Aligns the section close to the center
        inline: 'nearest',
      });

      // Slightly adjust the position to be a bit above the center
      setTimeout(() => {
        const offset = -50; // Adjust this value for how much higher you want
        const elementPosition =
          refs[id].current.getBoundingClientRect().top + window.pageYOffset + offset;
        window.scrollTo({
          top: elementPosition,
          behavior: 'smooth',
        });
      }, 300); // Adjust timeout if necessary for smoother behavior
    }
  };

  useEffect(() => {
    const opportunityId = location.state?.id || opportunityID;
    if (location.pathname.includes('viewOpportunity')) {
      setFormData({
        ...opportunityLocalData,
        type: 'view',
        from: 'view',
      });
      // }
    }
    if (opportunityId) {
      dispatch(
        fetchDetailAndAppendToModule({
          moduleName: 'Opportunity',
          id: opportunityId,
          localDetail: location.state || null,
        })
      );
      dispatch(
        fetchNotesAndAppendToModule({
          moduleName: 'Opportunity',
          id: opportunityId,
        })
      );
      dispatch(
        fetchAttachmentsAndAppendToModule({
          moduleName: 'Opportunity',
          id: opportunityId,
        })
      );
      dispatch(
        fetchEmailAndAppendToModule({
          moduleName: 'Opportunity',
          id: opportunityId,
        })
      );
      dispatch(
        fetchTagsAndAppendToModule({
          moduleName: 'Opportunity',
          id: opportunityId,
        })
      );
    }
  }, [location, opportunityLocalData?.id]);

  const handleOpenEditForm = (paramsValue) => {
    navigate('/opportunity/editOpportunity', {
      state: formData,
    });
  };

  const scrollContainerRef = useRef(null);

  useEffect(() => {
    const observerOptions = {
      root: scrollContainerRef.current,
      rootMargin: '0px 0px -310px 0px', // Adjusts the bottom margin to trigger when the section is halfway through the viewport
      threshold: 1,
    };

    const observerCallback = (entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          const sectionId = entry.target.id;
          setActiveTab(sectionId);
        }
      });
    };

    const observer = new IntersectionObserver(observerCallback, observerOptions);

    // Observe each section
    Object.values(refs).forEach((ref) => {
      if (ref.current) {
        observer.observe(ref.current);
      }
    });

    // Cleanup on unmount
    return () => {
      observer.disconnect();
    };
  }, []);
  return (
    <>
      {loading && <Loader />}
      <div className="ViewLeadPageOuter">
        <div className="viewHeader">
          <HeaderProfileBlock
            localData={opportunityLocalData}
            moduleName={'Opportunity'}
            View={true}
          />
          <div className="rightActionDskButton">
            <div className="rightAction">
              <button
                className="btn btn-outline-primary "
                onClick={handleOpenEditForm}
                disabled={!formData}
              >
                <img
                  src={edit}
                  alt="Edit"
                  className="me-2"
                  style={{ width: '12px', height: '12px' }}
                />
                <span className="btnText">Edit</span>
              </button>
            </div>
            <div className="mob">
              <div className="adnoteMob ms-2">
                <button
                  className="btn btn-primary"
                  data-bs-toggle="offcanvas"
                  data-bs-target="#offcanvasExample"
                  aria-controls="offcanvasExample"
                >
                  <img
                    src={addNote}
                    alt="Add a Note"
                    className="me-2"
                    style={{ width: '12px', height: 'auto' }}
                  />
                  <span className="btnText">Add a Note</span>
                </button>
              </div>
            </div>
          </div>
        </div>

        <div className="detailContainer">
          <div className="viewFormContainer">
            <div className="leftBlock">
              <ul>
                {Object.keys(refs).map((key) => (
                  <li
                    key={key}
                    onClick={() => scrollToSection(key)}
                    style={{ cursor: 'pointer' }}
                    className={activeTab === key ? 'leftbox activeList' : 'leftbox'}
                  >
                    <button onClick={() => setActiveTab(key)}>
                      {key.charAt(0).toUpperCase() + key.slice(1)}
                      {['openActivities', 'closedActivities', 'invitedMeetings'].includes(key) && (
                        <span style={{ fontSize: '7px', fontWeight: '600' }}> (Coming Soon)</span>
                      )}
                    </button>
                  </li>
                ))}
              </ul>
            </div>

            <div className="rightBlock" id="detailPageRight">
              <div className="addlead_container">
                <Formik
                  initialValues={formData}
                  onSubmit={(values) => handleSubmit(values)}
                  validationSchema={validationSchema}
                >
                  <Form>
                    <div className="row">
                      <div className="col-12 col-sm-12 col-md-12">
                        <div className="addleadcard1">
                          <div id="overview" className="scrollTo" ref={refs.overview}></div>
                          {formData && (
                            <DealForm formData={formData} selectedOptions={selectedOptions} />
                          )}
                        </div>

                        <div id="attachments" className="scrollTo" ref={refs.attachments}></div>
                        <Attachments localData={opportunityLocalData} module={'Opportunity'} />
                        <div id="timeline" className="scrollTo" ref={refs.timeline}></div>
                        <Timeline localData={opportunityLocalData} module={'Opportunity'} />
                      </div>
                    </div>
                  </Form>
                </Formik>
              </div>
            </div>
          </div>
          <div className="viewFormNotesOuter">
            <div className="ViewFormNotesContainer">
              <Formik
                initialValues={formData}
                onSubmit={(values) => handleSubmit(values)}
                validationSchema={validationSchema}
              >
                <Form>
                  <div id="notes" className="scrollTo" ref={refs.notes}></div>
                  <Notes leadLocalData={opportunityLocalData} module={'Opportunity'} />
                </Form>
              </Formik>
            </div>
          </div>
        </div>
        <div
          className="offcanvas addNoteMobBlock offcanvas-end"
          tabIndex="-1"
          id="offcanvasExample"
          aria-labelledby="offcanvasExampleLabel"
        >
          <div className="offcanvas-header">
            <h5 className="offcanvas-title" id="offcanvasExampleLabel">
              <img src="../assets/images/notesIcon.svg" alt="Note" width="16px" />
              Notes
            </h5>
            <button
              type="button"
              className="btn-close text-reset"
              data-bs-dismiss="offcanvas"
              aria-label="Close"
            ></button>
          </div>
          <div className="offcanvas-body">
            <div className="ViewFormNotesContainer">
              <Formik
                initialValues={formData}
                // onSubmit={(values) => handleSubmit(values)}
                validationSchema={validationSchema}
              >
                <Form id="viewForm">
                  <Notes leadLocalData={opportunityLocalData} module={'Opportunity'}></Notes>
                </Form>
              </Formik>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default ViewDeal;
